/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class VideoControl extends HTMLElement {
  constructor() {
    super();
    this.control = this.querySelector('[data-video-control]');
    this.isMuted = true;
    this.init();
  }
  init() {
    if (!this.control) return;
    const controlId = this.control.getAttribute('data-video-control');
    if (!controlId) return;
    this.videoSection = document.querySelector(`[data-video-control-id="${controlId}"]`);
    if (!this.videoSection) return;
    this.videoType = this.videoSection.getAttribute('data-type');
    this.unmutedIcon = this.control.querySelector('.video-control__icon--unmuted');
    this.mutedIcon = this.control.querySelector('.video-control__icon--muted');
    if (!this.unmutedIcon || !this.mutedIcon) return;
    if (this.videoType === 'youtube') {
      this.initYouTube();
    } else if (this.videoType === 'vimeo') {
      this.initVimeo();
    } else {
      this.video = this.videoSection.querySelector('video');
      if (!this.video) return;
      this.attachEvents();
      this.updateUI();
    }
  }
  initYouTube() {
    if (this.videoSection.player && typeof this.videoSection.player.mute === 'function') {
      this.setupYouTubeControl();
    } else {
      this.videoSection.addEventListener('youtube-ready', () => {
        this.setupYouTubeControl();
      }, {
        once: true
      });
    }
  }
  setupYouTubeControl() {
    this.youtubePlayer = this.videoSection.player;
    this.control.addEventListener('click', this.toggleMute.bind(this));
    if (this.youtubePlayer.isMuted && typeof this.youtubePlayer.isMuted === 'function') {
      this.isMuted = this.youtubePlayer.isMuted();
    }
    this.updateUI();
  }
  initVimeo() {
    if (this.videoSection.player && typeof this.videoSection.player.setMuted === 'function') {
      this.setupVimeoControl();
    } else {
      this.videoSection.addEventListener('vimeo-ready', () => {
        this.setupVimeoControl();
      }, {
        once: true
      });
    }
  }
  setupVimeoControl() {
    this.vimeoPlayer = this.videoSection.player;
    this.control.addEventListener('click', this.toggleMute.bind(this));
    this.vimeoPlayer.getMuted().then(muted => {
      this.isMuted = muted;
      this.updateUI();
    });
  }
  attachEvents() {
    this.control.addEventListener('click', this.toggleMute.bind(this));
    this.video.addEventListener('volumechange', this.updateUI.bind(this));
  }
  toggleMute(e) {
    e.preventDefault();
    if (this.videoType === 'youtube' && this.youtubePlayer) {
      if (this.isMuted) {
        this.youtubePlayer.unMute();
        this.isMuted = false;
      } else {
        this.youtubePlayer.mute();
        this.isMuted = true;
      }
      this.updateUI();
    } else if (this.videoType === 'vimeo' && this.vimeoPlayer) {
      this.isMuted = !this.isMuted;
      this.vimeoPlayer.setMuted(this.isMuted);
      this.updateUI();
    } else if (this.video) {
      this.video.muted = !this.video.muted;
    }
  }
  updateUI() {
    let isMuted;
    if (this.videoType === 'youtube' || this.videoType === 'vimeo') {
      isMuted = this.isMuted;
    } else {
      isMuted = this.video.muted;
    }
    this.unmutedIcon.classList.toggle('hidden', isMuted);
    this.mutedIcon.classList.toggle('hidden', !isMuted);
    this.control.setAttribute('aria-label', isMuted ? 'Activer le son' : 'Désactiver le son');
  }
  disconnectedCallback() {
    if (this.control) {
      this.control.removeEventListener('click', this.toggleMute);
    }
    if (this.video && this.videoType !== 'youtube' && this.videoType !== 'vimeo') {
      this.video.removeEventListener('volumechange', this.updateUI);
    }
  }
}
customElements.define('video-control', VideoControl);
/******/ })()
;